'use client';

import React from 'react';
import ReactHtmlParser from '@libs/reactHtmlParser';
import ParallaxText from '@components/ParallaxText';
import cn from './style.module.scss';
interface AlGhadeerParagraphProps {
  paragraphData: string;
}
export default function AlGhadeerParagraph({
  paragraphData,
}: AlGhadeerParagraphProps) {
  return (
    <ParallaxText
      className={cn.alGhadeerParagraph}
      variant="p"
      animationType="slideInBottom"
      animationDuration={500}
    >
      {ReactHtmlParser(paragraphData)}
    </ParallaxText>
  );
}
